export default "__VITE_ASSET__Dkey_vwG__"